export interface Location {
  address: string;
  latitude: string;
  longitude: string;
}

export class Location {
  constructor();
  constructor(address: string, lat: string, lng: string);
  constructor(...args: string[]) {
    if (!args?.length) {
      this.address = null;
      this.latitude = null;
      this.longitude = null;
    }
    if (args?.length === 3) {
      this.address = args[0];
      this.latitude = args[1];
      this.longitude = args[2];
    }
  }
}
